import CommonButton from "@components/CommonButton";
import "./EmptyStatus.scss";
import { IconEmpty, IconError } from "@icons/index";
import classNames from "classnames";
import { Trans, useTranslation } from "react-i18next";

interface ErrorStatusProps {
  className?: string;
  message?: string;
  isError?: boolean;
  isLoading?: boolean;
  isFinished?: boolean;
  onFresh?: () => void;
  onCollection?: Function | undefined;
  traceID?: string;
  BlankResult?: React.ReactNode;
}

const ErrorStatus = ({
  className,
  isError = false,
  isLoading = false,
  message = "No Result",
  onFresh,
  onCollection,
  traceID,
  BlankResult,
  isFinished,
}: ErrorStatusProps) => {
  const { t } = useTranslation();
  return (
    <div className={classNames("Layout-TablePagination-EmptyStatus", className)}>
      {!isLoading &&
        !isError &&
        isFinished &&
        (BlankResult ? (
          BlankResult
        ) : (
          <div className="flex flex-col items-center">
            <IconEmpty></IconEmpty>
            {!onCollection && (
              <div className="text-kds-fg">
                <Trans>{message}</Trans>
              </div>
            )}
          </div>
        ))}
      {!isLoading && isError && (
        <div className="flex flex-col items-center">
          <IconError className="mb-3"></IconError>
          {!onCollection && (
            <div>
              <Trans>{message}</Trans>
            </div>
          )}
        </div>
      )}
      {!isLoading && isError && traceID && (
        <div className="traceID">
          <Trans>Trace ID</Trans>: {traceID}
        </div>
      )}
      {!isLoading && !isError && onCollection && isFinished && (
        <div className="collection_wrapper">
          <div className="collection_text">
            <Trans>Sorry, the creator you searched is not included, please click"Add Creator" button below.</Trans>
          </div>
          <CommonButton
            className="w-[152px] px-5!"
            type="primary"
            onClick={() => {
              onCollection && onCollection();
            }}
          >
            {t("Add Creator")}
          </CommonButton>
        </div>
      )}
      {isError && (
        <CommonButton
          size="middle"
          type="primary"
          className="mt-[24px]"
          onClick={() => {
            onFresh && onFresh();
          }}
        >
          {t("Reload")}
        </CommonButton>
      )}
    </div>
  );
};

export default ErrorStatus;
